import { render, staticRenderFns } from "./SnoozeButton.vue?vue&type=template&id=64b391e4&"
import script from "./SnoozeButton.vue?vue&type=script&lang=js&"
export * from "./SnoozeButton.vue?vue&type=script&lang=js&"
import style0 from "./SnoozeButton.vue?vue&type=style&index=0&id=64b391e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports